$(document).ready(function () {
  // ===== CACHE MANAGEMENT =====
  const BudgetItemsCache = {
    getCacheKey: function(startMonth) {
      return `budget_items_${startMonth}`;
    },

    save: function(startMonth) {
      const cacheKey = this.getCacheKey(startMonth);
      const items = this.collectCurrentItems();

      if (Object.keys(items).length > 0) {
        sessionStorage.setItem(cacheKey, JSON.stringify(items));
      }
    },

    load: function(startMonth) {
      const cacheKey = this.getCacheKey(startMonth);
      const cached = sessionStorage.getItem(cacheKey);

      if (cached) {
        try {
          return JSON.parse(cached);
        } catch (e) {
          console.error('Error parsing cache:', e);
          return {};
        }
      }
      return {};
    },

    clear: function(startMonth) {
      if (startMonth) {
        const cacheKey = this.getCacheKey(startMonth);
        sessionStorage.removeItem(cacheKey);
      } else {
        // Clear all budget_items cache
        Object.keys(sessionStorage).forEach(key => {
          if (key.startsWith('budget_items_')) {
            sessionStorage.removeItem(key);
          }
        });
      }
    },

    collectCurrentItems: function() {
      const items = {};
      const $table = $('#budget-items-table');

      if ($table.length === 0) return items;

      $table.find('tr[data-row="sales"] td').each(function(index) {
        const $td = $(this);
        const $monthInput = $td.find('input[type="hidden"][name*="[month]"]');
        const $salesInput = $td.find('.js-sales');
        const $gpInput = $('tr[data-row="gross_profit"] td').eq(index).find('.js-gross-profit');
        const $purchaseInput = $('tr[data-row="purchase"] td').eq(index).find('.js-purchase');
        if ($monthInput.length > 0) {
          const month = $monthInput.val();
          const monthKey = normalizeMonthKey(month);

          if (monthKey) {
            items[monthKey] = {
              month: month,
              sales: parseMoney($salesInput.val()),
              gross_profit: parseMoney($gpInput.val()),
              purchase_amount: parseMoney($purchaseInput.val())
            };
          }
        }
      });

      return items;
    },

    restore: function(startMonth) {
      const cached = this.load(startMonth);
      if (Object.keys(cached).length === 0) {
        return;
      }

      const $table = $('#budget-items-table');
      if ($table.length === 0) return;

      $table.find('tr[data-row="sales"] td').each(function(index) {
        const $td = $(this);
        const $monthInput = $td.find('input[type="hidden"][name*="[month]"]');

        if ($monthInput.length > 0) {
          const month = $monthInput.val();
          const monthKey = normalizeMonthKey(month);
          const cachedItem = cached[monthKey];

          if (cachedItem) {
            const $salesInput = $td.find('.js-sales');
            const $gpInput = $('tr[data-row="gross_profit"] td').eq(index).find('.js-gross-profit');
            const $purchaseInput = $('tr[data-row="purchase"] td').eq(index).find('.js-purchase');

            // Restore values - always restore if exists in cache, including negative values
            if ($salesInput.length > 0) {
              const salesValue = cachedItem.sales;
              $salesInput.val(salesValue !== undefined && salesValue !== null ? formatMoney(salesValue) : '');
            }

            if ($gpInput.length > 0) {
              const gpValue = cachedItem.gross_profit;
              $gpInput.val(gpValue !== undefined && gpValue !== null ? formatMoney(gpValue) : '');
            }

            if ($purchaseInput.length > 0) {
              const purchaseValue = cachedItem.purchase_amount;
              $purchaseInput.val(purchaseValue !== undefined && purchaseValue !== null ? formatMoney(purchaseValue) : '');
            }

            // Recalculate purchase after restoring
            setTimeout(function() {
              recalcPurchaseByCol($table, index);
            }, 10);
          }
        }
      });
    }
  };

  // Helper functions
  function normalizeMonthKey(monthValue) {
    if (!monthValue) return null;

    // Handle different date formats: "2024-01-01", "2024/01/01", Date object string
    const dateStr = monthValue.toString();
    const match = dateStr.match(/(\d{4})[-\/](\d{1,2})/);

    if (match) {
      const year = match[1];
      const month = match[2].padStart(2, '0');
      return `${year}-${month}`;
    }

    return null;
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return '';
    if (numValue === 0) return '';
    return numValue.toLocaleString('en-US');
  }

  function parseMoney(val) {
    if (val === null || val === undefined || val === '') return 0;
    const cleaned = val.toString()
      .replace(/,/g, "")
      .replace(/[０-９]/g, function(ch) { return String.fromCharCode(ch.charCodeAt(0) - 0xfee0); })
      .replace(/[−ー－]/g, '-')
      .replace(/[．。]/g, '.');
    const numValue = parseFloat(cleaned);
    return isNaN(numValue) ? 0 : numValue;
  }

  // ===== EVENT HANDLERS =====
  $(document).on("click", "#apply-period", function (e) {
    e.preventDefault();


    // ===== APPLY PERIOD =====
    const startMonth   = $("#budget_table_start_month").val();
    const period       = $("#budget_table_period").val();
    const duration     = $("#budget_table_duration").val();
    const department_id = $("#budget_table_department_id").val();

    if (!startMonth || !duration) {
      alert("開始年月と期を入力してください");
      return false;
    }

    if (!period){
      alert("開始年月と期を入力してください");
      return false;
    }

    if (period.length > 8) {
      alert("8桁以内で入力してください。");
      return false;
    }

    // Check if period is not a decimal (only integer)
    if (period.toString().includes('.')) {
      alert("期は整数で入力してください。");
      return false;
    }

    if (!period) {
      alert("期を入力してください");
      return false;
    }

     const periodNum = parseInt(period);
     if (isNaN(periodNum) || periodNum <= 0) {
       alert("期は1以上の数値を入力してください。");
       return false;
     }

    // Get previous start_month from hidden input
    const previousStartMonth = $("#builder_start_month").val();

    // Check if start_month changed
    if (previousStartMonth && previousStartMonth !== startMonth) {
      // Start month changed - clear cache for previous month
      BudgetItemsCache.clear(previousStartMonth);
    } else {
      // Start month unchanged - load current items to cache
      BudgetItemsCache.load(startMonth);
    }

    $.ajax({
      url: '/budget_tables/validate_period',
      method: 'POST',
      data: {
        department_id: department_id,
        period: period,
        start_month: startMonth,
        duration: duration
      },
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      success: function(response) {
        if (response.valid) {
          proceedWithApply(startMonth, period, duration, department_id);
        }
      },
      error: function(xhr) {
        if (xhr.status === 422) {
          const response = JSON.parse(xhr.responseText);
          if (response.errors && response.errors.length > 0) {
            alert(response.errors.join("\n"));
          }
        } else {
          alert("バリデーションエラーが発生しました。");
          return false;
        }
      }
    });
  });

  function proceedWithApply(startMonth, period, duration, department_id) {
    $("#builder_start_month").val(startMonth);
    $("#builder_period").val(period);
    $("#builder_duration").val(duration);
    $("#builder_department_id").val(department_id);
    $("#budget-items-builder-form").submit();
  }

  // Restore cached data after page load
  function attemptRestore() {
    const startMonth = $("#budget_table_start_month").val();
    const $table = $('#budget-items-table');

    if (startMonth && $table.length > 0) {
      const hasItems = $table.find('tr[data-row="sales"] td').length > 0;
      if (hasItems) {
        BudgetItemsCache.restore(startMonth);
        return true;
      }
    }
    return false;
  }

  // Try to restore immediately and with delays
  if (!attemptRestore()) {
    setTimeout(function() {
      if (!attemptRestore()) {
        setTimeout(attemptRestore, 200);
      }
    }, 100);
  }

  // Auto-save on input change (debounced)
  let saveTimeout;
  $(document).on("input", ".js-sales, .js-purchase", function () {
    const $table = $(this).closest("table");   // 👈 scope table
    const colIndex = $(this).closest("td").data("col-index");
    const rawVal = $(this).val();
    if (rawVal !== null && rawVal !== undefined && rawVal.toString().trim() === "") {
      $(this).val("0");
    }

    recalcPurchaseByCol($table, colIndex);

    // Debounce cache save
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(function() {
      const startMonth = $("#budget_table_start_month").val();
      if (startMonth) {
        BudgetItemsCache.save(startMonth);
      }
    }, 300);
  });

  //Calc purchase
  function recalcPurchaseByCol($table, colIndex) {
    const $salesInput = $table.find('tr[data-row="sales"] td').eq(colIndex).find('.js-sales');

    const $purchaseInput = $table.find('tr[data-row="purchase"] td').eq(colIndex).find('.js-purchase');
    const $grossProfit = $table.find('tr[data-row="gross_profit"] td').eq(colIndex).find('.js-gross-profit');

    if (!$salesInput.length || !$grossProfit.length || !$purchaseInput.length) return;

    const sales       = parseMoney($salesInput.val());
    const purchase = parseMoney($purchaseInput.val());
    const grossProfit    = sales - purchase;

    $grossProfit.val(grossProfit.toLocaleString('en-US'));
  }

  // ===== SAVE BUTTON STATE MANAGEMENT =====
  var isApplied = false;
  var lastAppliedPeriod = localStorage.getItem('lastAppliedPeriod');


  // Track when Apply button is clicked successfully
  $(document).on("click", "#apply-period", function (e) {
    const period = $("#budget_table_period").val();
    // Store applied values for later comparison
    localStorage.setItem('lastAppliedPeriod', period);
    isApplied = true;

    // Enable save button after successful apply
    setTimeout(function() {
      if ($("#budget-items-table").length > 0) {
        $(".btn-submit-budget-table").prop("disabled", false);
      }
    }, 500);
  });


  // Monitor changes to start_month and period after apply
  $(document).on("change", "#budget_table_period", function() {
    if (!isApplied) {
      const currentPeriod = $("#budget_table_period").val();
      // If values changed after apply, disable save button
      if (currentPeriod !== lastAppliedPeriod) {
        isApplied = false;
      }
    }
  });

  // ===== SAVE BUTTON VALIDATION =====
  $(document).on('submit', '#budget-table-form', function (e) {

    const $submitBtn   = $(".btn-submit-budget-table");
    const departmentId = $("#budget_table_department_id").val();
    const period       = $("#budget_table_period").val();
    const startMonth   = $("#budget_table_start_month").val();
    const currentPeriod = period;
    const $table       = $("#budget-items-table");

    // Abort: prevent submit, re-enable button so user can retry after alert
    function rejectWith(message) {
      e.preventDefault();
      $submitBtn.prop("disabled", false);
      alert(message);
    }

    if ($table.length === 0) {
      return rejectWith("予算データが登録されていません。");
    }

    // Case 1: department
    if (!departmentId || departmentId === "") {
      return rejectWith("部署を入力してください");
    }

    // Case 2: period presence
    if (!period || period === "") {
      return rejectWith("期を入力してください");
    }

    // Case 3: start month
    if (!startMonth || startMonth === "") {
      return rejectWith("開始年月を入力してください。");
    }

    // Case 4: period must be positive integer
    const periodNum = parseInt(period);
    if (isNaN(periodNum) || periodNum <= 0) {
      return rejectWith("期は1以上の数値を入力してください。");
    }

    // Case 6: form modified after apply
    if (!isApplied && currentPeriod !== lastAppliedPeriod) {
      return rejectWith("開始年月または期間が変更されました。再度「適用」ボタンを押してください");
    }

    // Case 7: digit length (max 8 digits)
    let digitError = false;
    $(".js-sales, .js-purchase").each(function () {
      const rawVal = $(this).val() ? $(this).val().toString().replace(/-/g, '') : '';
      if (rawVal && parseMoney($(this).val()) !== 0 && rawVal.replace(/[^0-9]/g, '').length > 8) {
        digitError = true;
        return false;
      }
    });
    if (digitError) {
      return rejectWith("8桁以内で入力してください。");
    }

    // Case 8: no decimals allowed
    let decimalError = false;
    $("#budget_table_period, .js-sales, .js-gross-profit, .js-purchase").each(function () {
      const rawVal = $(this).val();
      if (rawVal && rawVal.toString().includes('.')) {
        decimalError = true;
        return false;
      }
    });
    if (decimalError) {
      return rejectWith("整数で入力してください。");
    }

    // All validations passed — re-enable disabled fields so their values are submitted,
    // then clear cache and let browser submit naturally
    $("#budget_table_period").prop("disabled", false);
    $("#budget_table_start_month").prop("disabled", false);
    $("#budget_table_duration").prop("disabled", false);
    BudgetItemsCache.clear(startMonth);
  });

  //Clear cache when new button is clicked
  $(document).on("click", 'a[href*="budget_tables/new"]', function () {
    BudgetItemsCache.clear();
  });

  //Show/hide button submit
  if($('#budget-items-table').length > 0){
    $(".btn-submit-budget-table").show();
    $("#apply-period").hide();
    $("#budget_table_period").prop("disabled", true);
    $("#budget_table_start_month").prop("disabled", true);
    $("#budget_table_duration").prop("disabled", true);
    $('.clear-icon').hide();
  }else{
    $(".btn-submit-budget-table").hide();
    $("#apply-period").show();
    $("#budget_table_period").prop("disabled", false);
    $("#budget_table_start_month").prop("disabled", false);
    $("#budget_table_duration").prop("disabled", false);
    $('.clear-icon').show();
  }

  // ===== ENTER KEY NAVIGATION =====
  // Prevent default form submission on Enter key
  $(document).on("keydown", "#budget-table-form, #bulk-edit-form", function(e) {
    if (e.key === "Enter" && !$(e.target).is("button, input[type=submit]")) {
      e.preventDefault();
      return false;
    }
  });

  // Handle Enter key navigation for sales and purchase inputs
  $(document).on("keydown", ".js-sales, .js-purchase", function(e) {
    if (e.key === "Enter") {
      e.preventDefault();

      const $currentInput = $(this);
      const $currentTd = $currentInput.closest("td");
      const $currentTable = $currentInput.closest("table");
      const currentColIndex = $currentTd.data("col-index");
      const isSalesRow = $currentTd.closest("tr").data("row") === "sales";

      // Check if we're in the purchase row (last editable row)
      const isPurchaseRow = $currentTd.closest("tr").data("row") === "purchase";

      if (isSalesRow) {
        // Move from sales to purchase in the same column
        const $purchaseInput = $currentTable
          .find('tr[data-row="purchase"] td')
          .eq(currentColIndex)
          .find('.js-purchase');

        if ($purchaseInput.length > 0) {
          $purchaseInput.focus().select();
          return false;
        }
      } else if (isPurchaseRow) {
        // We're in purchase row - check if there's a next column
        const totalCols = $currentTable.find('tr[data-row="sales"] td').length;
        const nextColIndex = currentColIndex + 1;

        if (nextColIndex < totalCols) {
          // Move to sales input of next column
          const $nextSalesInput = $currentTable
            .find('tr[data-row="sales"] td')
            .eq(nextColIndex)
            .find('.js-sales');

          if ($nextSalesInput.length > 0) {
            $nextSalesInput.focus().select();
            return false;
          }
        } else {
          // We're at the last column's purchase input
          // Check if we're in new/edit mode and handle accordingly
          const isEditMode = $('#bulk-edit-form').length > 0;

          if (isEditMode) {
            // Edit mode: Check if this is the last table
            const $currentBudgetTableContainer = $currentTable.closest('[data-budget-table-id]');
            const currentBudgetTableId = $currentBudgetTableContainer.data('budget-table-id');
            const $allBudgetTables = $('[data-budget-table-id]');
            const currentTableIndex = $allBudgetTables.index($currentBudgetTableContainer);
            const isLastTable = currentTableIndex === $allBudgetTables.length - 1;

            if (!isLastTable) {
              // Not the last table - focus on expense budget button of current table
              const $expenseButton = $currentBudgetTableContainer.find('.js-open-expense-budget-modal');
              if ($expenseButton.length > 0) {
                $expenseButton.focus();
                return false;
              }
            } else {
              // Last table - focus on bulk save button
              const $bulkSaveButton = $('#bulk-edit-form').find('input[type="submit"]').first();
              if ($bulkSaveButton.length > 0) {
                // ===== SCROLL TO TOP ON SUBMIT BUTTON FOCUS =====
                $('html, body').animate({ scrollTop: 0 }, 100);
                $bulkSaveButton.focus();
                return false;
              }
            }
          } else {
            // New mode: focus on save button
            const $saveButton = $('.btn-submit-budget-table').first();
            if ($saveButton.length > 0) {
              // ===== SCROLL TO TOP ON SUBMIT BUTTON FOCUS =====
              $('html, body').animate({ scrollTop: 0 }, 100);
              $saveButton.focus();
              return false;
            }
          }
        }
      }

      return false;
    }
  });

  // Handle Enter key on expense budget button (edit mode only)
  $(document).on("keydown", ".js-open-expense-budget-modal", function(e) {
    if (e.key === "Enter") {
      e.preventDefault();

      const $currentButton = $(this);
      const $currentBudgetTableContainer = $currentButton.closest('[data-budget-table-id]');
      const $allBudgetTables = $('[data-budget-table-id]');
      const currentTableIndex = $allBudgetTables.index($currentBudgetTableContainer);
      const nextTableIndex = currentTableIndex + 1;

      if (nextTableIndex < $allBudgetTables.length) {
        // Move to the first sales input of the next table
        const $nextTable = $allBudgetTables.eq(nextTableIndex);
        const $nextSalesInput = $nextTable
          .find('tr[data-row="sales"] td')
          .first()
          .find('.js-sales');

        if ($nextSalesInput.length > 0) {
          $nextSalesInput.focus().select();
          return false;
        }
      } else {
        // This is the last table - focus on bulk save button
        const $bulkSaveButton = $('#bulk-edit-form').find('input[type="submit"]').first();
        if ($bulkSaveButton.length > 0) {
          $bulkSaveButton.focus();
          return false;
        }
      }

      return false;
    }
  });

});
